import React from "react";
import styled from "styled-components";

interface JargonButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

const StyledJargonButton = styled.button`
  font-size:1rem;
  padding: 20px 25px;
  background-color: var(--jargon-secondary);
  color: white;
  border: 2px solid var(--jargon-secondary);
  cursor: pointer;
  margin-bottom:45px;
  align-self: flex-start;
  
  &:hover:not(:disabled) {
    background-color: white;
    color: var(--jargon-secondary);
    border: 2px solid var(--jargon-secondary);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  transition: opacity var(--fade-duration) ease-in-out;
`;

const JargonButton: React.FC<JargonButtonProps> = ({ children, ...rest }) => {
  return (
    <StyledJargonButton {...rest}>
      {children}
    </StyledJargonButton>
  );
};

export default JargonButton;